import React from "react";
import { IBucketFilterParams } from "api/entities/bucket";
import SearchInput from "components/shared-ui/input/search-input/search-input";
import { FiltersBar } from "components/shared-ui/manage-items/filters-bar/filters-bar";
import styles from "components/access-credentials/filters/credential-panel-filters/credential-user-section-filters.module.scss";

export enum UserListFilter {
    Search = "search"
}

export interface ICredentialDetailsPanelUserListFiltersProps {
    title?: string;
    visibleFilters?: UserListFilter[];
    filteredText: string;
    onFiltersChange: (searchText: string) => void;
}

export function CredentialUserSectionFilters(props: ICredentialDetailsPanelUserListFiltersProps) {
    const filters = props.visibleFilters || [UserListFilter.Search];

    return (
        <FiltersBar
            title={props.title || "USER LIST"}
        >
            {filters.includes(UserListFilter.Search) && (
                <SearchInput
                    className={styles.search}
                    value={props.filteredText}
                    onChange={q => props.onFiltersChange( q )}
                />
            )}
        </FiltersBar>
    );
}
